import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { COMPLETE_STATUS, DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import FinalDelayReportView from "./FinalDelayReportView";
import FinalLoadingReportView from "./FinalLoadingReportView";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.detail.final-report`;

/**
 * DBCO-0059 (R-31, R-32) - the Final Report tab: the Final Loading Report always, and the Final Delay Report only once the
 * operation is Complete (AD-99). The sub-tabs are local state with no URL, like the page's own tabs (DBCO-0030 D7).
 */
const FinalReportTab: React.FC<{ operationId: string; status: string | null | undefined }> = ({
  operationId,
  status,
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(0);
  const complete = status === COMPLETE_STATUS;
  const index = complete ? selected : 0;

  return (
    <Box
      data-testid="drybulk-cargo-operation-final-report"
      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
    >
      <Tabs
        value={index}
        onChange={(_, value: number) => setSelected(value)}
        aria-label={t(`${L}.tabs.label`)}
        data-testid="drybulk-cargo-operation-final-report-tabs"
        sx={{
          "borderBottom": "1px solid var(--stroke-secondary-stroke, #E6EDF2)",
          "minHeight": 40,
          "& .MuiTab-root": {
            textTransform: "none",
            fontSize: "1rem",
            minHeight: 40,
            minWidth: "auto",
            px: 2,
          },
        }}
      >
        <Tab
          label={t(`${L}.tabs.loading`)}
          data-testid="drybulk-cargo-operation-final-report-tab-loading"
        />
        {complete && (
          <Tab
            label={t(`${L}.tabs.delay`)}
            data-testid="drybulk-cargo-operation-final-report-tab-delay"
          />
        )}
      </Tabs>
      {index === 0 ? (
        <FinalLoadingReportView operationId={operationId} status={status} />
      ) : (
        <FinalDelayReportView operationId={operationId} />
      )}
    </Box>
  );
};

export default FinalReportTab;
